



























import {Component, Emit, Prop, Provide, Vue} from 'vue-property-decorator'
import {Contract} from '@/model/resource/Contract'
import {InputTokenPricedSchema} from '@/schema/resource/TokenPriced/InputTokenPricedSchema'

@Component
export default class PersistContractNep17View extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputTokenPricedSchema()
  contract = new Contract()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.contract.getContract(id)
    }

    this.$await.done('getContract')
  }

  @Emit('persist')
  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      this.$toast.abort('system.error.validation')
    }
    return this.contract
  }
}
